const initHeaderPlataforma = () => {
    document.addEventListener("DOMContentLoaded", function () {
        const header = document.querySelector(".mi-cuenta__top-nav");

        if (!header) return;

        const showDropdown = document.querySelector(".dropdown-show-on-click");
        const dropdownMenu = document.querySelector(".dropdown");

        showDropdown.addEventListener("click", function () {
            showDropdown.classList.toggle("active");
            dropdownMenu.classList.toggle("active");
        });
    });
}

export default initHeaderPlataforma;